import React from 'react'
import './comment-card.scss'

const CommentCard = props => {
    
    return (
        <div className="f-comment-card">
            <img src={props.image} alt="Icono usuario" />
            <div className="f-comment-card-info">
                <label className="f-comment-card-info-name"><b>{props.name}</b></label>
                <p className="f-comment-card-info-comment">{props.comment}</p>
                <div className="f-comment-card-info-stars">
                        <div className="f-stars-container">
                            {
                                props.stars
                            }
                        </div>
                    <small>{props.date}</small>
                </div>
            </div>
        </div>
    )
}

export default CommentCard